import { EffectPreview, RenderFn } from './ScenePreview';

export default (fadeDuration: number) => {
  const beforeFrameDrawn: RenderFn = (ctx, preview) => {
    const relativeTime =
      preview.time - preview.settings.trimStart - (preview.settings.duration - fadeDuration);
    ctx.globalAlpha = relativeTime < 0 ? 1 : (fadeDuration - relativeTime) / fadeDuration;
  };

  const afterFrameDrawn: RenderFn = ctx => {
    ctx.globalAlpha = 1;
  };

  const effectPreview: EffectPreview = { beforeFrameDrawn, afterFrameDrawn };

  return effectPreview;
};
